// SPDX-License-Identifier: AGPL-3.0-or-later
import styles from '@app/features/game_activity/components/GameActivityIcon.module.css';
import {useGameActivityIcon} from '@app/features/game_activity/hooks/useGameActivityIcon';
import type {GameActivity} from '@app/features/gateway/types/GatewayPresenceTypes';
import {Tooltip} from '@app/features/ui/tooltip/Tooltip';
import {GameControllerIcon} from '@phosphor-icons/react';
import {clsx} from 'clsx';

export function GameActivityIcon({activity, className}: {activity: GameActivity; className?: string}) {
	const {label, iconUrl} = useGameActivityIcon(activity);
	return (
		<Tooltip text={label} position="top" data-flx="game-activity.icon.tooltip">
			<span className={clsx(styles.root, className)} role="img" aria-label={label} data-flx="game-activity.icon">
				{iconUrl ? (
					<img
						className={styles.image}
						src={iconUrl}
						alt=""
						width={16}
						height={16}
						data-flx="game-activity.game-activity-icon.image"
					/>
				) : (
					<GameControllerIcon
						className={styles.fallback}
						aria-hidden
						data-flx="game-activity.game-activity-icon.fallback"
					/>
				)}
			</span>
		</Tooltip>
	);
}
